import { render } from "./admissionManager.vue?vue&type=template&id=4e3fb224"
import script from "./admissionManager.vue?vue&type=script&lang=js"
export * from "./admissionManager.vue?vue&type=script&lang=js"

import "./admissionManager.vue?vue&type=style&index=0&id=4e3fb224&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__